import { PropsWithChildren } from 'react';
import { useTheme } from '@mui/material';

import { Flex } from '@/components/utils';

export const NavBarContainer = ({ children }: PropsWithChildren) => {
  const { zIndex } = useTheme();

  return (
    <Flex
      column
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        zIndex: zIndex.appBar,
        height: '100vh',
        width: '60px',
        background: 'white',
        alignItems: 'center',
        gap: '8px',
        py: '.5rem',
        borderRight: '1px solid #e0e0e0',
      }}
    >
      {children}
    </Flex>
  );
};
